import { Kpi } from '../../../../models/common';
import { platformIconPath } from '../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
var NewKpiComponent = /** @class */ (function () {
    function NewKpiComponent(translate, pdfService) {
        this.translate = translate;
        this.pdfService = pdfService;
    }
    NewKpiComponent.prototype.ngOnChanges = function (changes) {
        if (changes.kpi) {
            var kpi = changes.kpi.currentValue;
            this.hasNoData = kpi === null || kpi === undefined;
        }
    };
    NewKpiComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady('NewKpiComponent');
    };
    Object.defineProperty(NewKpiComponent.prototype, "engagementRateTooltip", {
        get: function () {
            if (!this.kpi) {
                return null;
            }
            if (this.kpi.platformName && (this.kpi.platformName.toLocaleLowerCase() === platformIconPath.instagram.name.toLocaleLowerCase()
                || this.kpi.platformName.toLocaleLowerCase() === platformIconPath.youtube.name.toLocaleLowerCase()
                || this.kpi.platformName.toLocaleLowerCase() === platformIconPath.blogs.name.toLocaleLowerCase()
                || this.kpi.platformName.toLocaleLowerCase() === platformIconPath.tiktok.name.toLocaleLowerCase())) {
                return this.translate.instant("info_box.influencer.engagement_rate_" + this.kpi.platformName.toLocaleLowerCase());
            }
            return this.translate.instant('info_box.influencer.engagement_rate');
        },
        enumerable: true,
        configurable: true
    });
    return NewKpiComponent;
}());
export { NewKpiComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi.component.ts.pre-build-optimizer.js